<template>
  <div>
    <div class="row mt-1 ml-0">
      <a class="btn-link smaller" href="#"
            @click="addUser()">
        <i class="fa fa-plus"></i> Add User
      </a>
    </div>
    <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave"
              @row-click="rowClick"
              id="usersTable" class="table-striped" 
              :data="data" :row-class-name="rowClasses">
      <!-- <el-table-column type="index">

      </el-table-column> -->

      <el-table-column prop="name" label="Name"/>

      <el-table-column prop="email" label="Email"/>

      <el-table-column prop="profile" label="Profile" width="130">
        <template slot-scope="{row}">
          {{$store.getters.usersSetup.userProfilesJson[row.profileId].name}}
        </template>
      </el-table-column>

      <el-table-column width="30">
        <template slot-scope="{row}">
          <a v-if="row.deletable" class="btn-danger btn-link" v-tooltip.top-center="'Delete'"
                                  @click="removeUser(row.id, $event)">
            <i :class="'fa fa-times'+' user'+row.id"></i>
          </a>
        </template>
      </el-table-column>

      <el-table-column width="1">
        <template slot-scope="{row}">
          <div :userid="row.id"/>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import {Payout, Lead, User} from 'src/classes/datamodel.js'
export default {
    name: 'Users-Table',
    props: {},
    computed: {
      data () {
        return this.$store.getters.users
      }
    },
    methods: {
      addUser () {
        this.$store.dispatch('openModal', {name: 'User', mode: 'Create',
                                           object: new User()})
        console.log('addUser(): ', this.$newTest)
      },
      editUser (row) {
        console.log('editUser(): ', row)
        this.$store.dispatch('openModal', {name: 'User', mode: 'Edit',
                                           object: new User(row)} )
      },
      async removeUser (userId, event) {
        var user = this.$store.getters.users.find(elem => elem.id == userId)
        const res = await this.$store.dispatch('deleteRestObject', user)
        if (res.errors) {
          if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
            this.$notify({ errorMessage: res.errors[0] })
          }
        }
        else { this.$notify({ successMessage: 'Deleted!'})
              this.closeModal()
        }
      },
      rowClasses ({row, rowIndex}) {
        return row.archived?'archivedTableRow clickableRow':'clickableRow'
      },
      rowHover(row, column, cell, event) {
        // We show all buttons of class .showOnHover
        var rows = $('#usersTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var foundRow = JSON.stringify($(rows[i]).html().indexOf('userid="'+row.id+'"')) > -1
          var archivedRow = $(rows[i]).attr('class').indexOf('archivedTableRow') > -1
          if (foundRow && !archivedRow) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).removeClass('d-none')
            }
            break
          }
        }
      },
      rowHoverLeave (row, column, cell, event) {
        // We hide all buttons of class .showOnHover
        var rows = $('#usersTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var index = JSON.stringify($(rows[i]).html().indexOf('userid="'+row.id+'"'))
          if (index > -1) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).addClass('d-none')
            }
            break
          }
        }
      },
      rowClick (row, column, event) {
        // We check to see if the click happened on an icon button
        var path = event.path || event.composedPath()
        var match = JSON.stringify(path[0].className).match(/fa[rsdl]{0,1}\sfa-/i)
        if (match && match.index > -1) {
          // icon button, we ignore row click
        } else {
          //console.log('row click')
          this.editUser(row)
        }
      }
    }
}
</script>

<style>
.el-table__row .cell {
  padding: 0;
}
.has-gutter .is-leaf .cell {
  padding: 0;
}
</style>